export enum ActionTypes {
    Talk = "talk",
    GoTo = "go to",
    PickUp = "pick up",
    Open = "open",
    Hide = "hide",
    Examine = "examine",
    Give = "give",
    WalkAway = "walk away",
    Press = "Press",
}
